module.exports = __webpack_public_path__ + "static/media/hide.70e9522e.svg";